module.exports = __webpack_public_path__ + "static/media/slide-3-background-short.1aa6cf5f.svg";